import React, { useEffect, useRef, useState } from "react";
import { withRouter, useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, height } from "@fortawesome/free-solid-svg-icons/faMagnifyingGlass";
import "./main.scss";
import { requestGet, agmsClientRequestGet, agmsClientRequestPost } from "../../apis/request";
import Loading from "../../assets/uxnicon/loadingIcon.png";
import moment from "moment";

import { userID, selectedExperimentState, seletedPatientIdState, isCurrentBloodSugarAtom } from "../../states/recoilState";
import { useSetRecoilState } from "recoil";
import {atom, useRecoilState} from 'recoil';
import { Redirect } from "react-router-dom";

import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { FixedSizeList } from 'react-window';

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import PatientTable from './PatientListComponents/PatientTable'
import RangeAreaChart from './Charts/RangeAreaChart';
import SearchTextfield from "./Inputs/SearchTextfield";

import agmsLogo from './imgs/agms 2.svg';
import ClickableList from './PatientListComponents/UserDeviceList'
// import { Label } from "reactstrap";

// import '../../App.css'
//jQuery librarie
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-select/js/dataTables.select"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import $ from 'jquery'; 


import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Unstable_Grid2';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import secureLocalStorage from "react-secure-storage";

import MenuItem from '@mui/material/MenuItem';

import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';

import USER_IDENTITY from '../../constants/Constants';
import { useTranslation } from "react-i18next";
import { Button, Switch, FormControlLabel } from '@mui/material';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  border: '1.5px solid #5E2589'
}));


const PatientList = () => {
	const { t:translate, i18n } = useTranslation();

	const [loading, setLoading] = useState(false);
	const [tableLoading, setTableLoading] = useState(false);
	const setuserID = useSetRecoilState(userID);
	const history = useHistory();
	const location = useLocation();
	const [tableData, setTableData] = useState([]);

	const [searchInputValue, setSearchInputValue] = useState('');
	const [selectedExperimentValue, setSelectedExperiment] = useRecoilState(selectedExperimentState);

	//요약 그래프용
	const [lineSeriesData, setLineSeriesData] = useState([]);
	const [middleAreaSeriesData, setMiddleAreaSeriesData] = useState([]);
	const [mainUpperAreaSeriesData, setUpperMainAreaSeriesData] = useState([]);
	const [mainLowerAreaSeriesData, setLowerMainAreaSeriesData] = useState([]);

	const [upperLimit, setUpperLimit]= useState([]);
	const [lowerLimit, setLowerLimit]= useState([]);

	const [selectedPatientId, setSeletedPatientId] = useRecoilState(seletedPatientIdState);
	const [isCurrentBloodSugar, setIsCurrentBloodSugar] = useRecoilState(isCurrentBloodSugarAtom);

	const [userDeviceList, setUserDeviceList] = useState([{}]);
	const [userDeviceListLoading, setUserDeviceListLoading] = useState(true);

	//유저 정보
	const [userInfo, setUserInfo] = useState({
		name : '',
		sex : '',
		height : 0,
		weight : 0,
		email : ''
	});

	//평균값
	const [averageData, setAverageData] = useState([]);
	//최고값
	const [maxData, setMaxData] = useState([]);
	//최저값
	const [minData, setMinData] = useState([]);
	//측정일수
	const [measurementPeriod, setMeasurementPeriod] = useState([]);
	//CGM활성화율
	const [activePercent, setActivePercent] = useState([]);
	//기기타입
	const [deviceTypeInfo, setDeviceTypeInfo] = useState([]);

	//로그인 창 다음인지
	const [isAfterLogin, setIsAfterLogin]= useState(false);

	const handleToWeeklyChart = () => {
	if (userDeviceListLoading || !userDeviceDate) return; // 로딩중·미선택이면 진입 차단(빈 프로파일 방지)
	secureLocalStorage.removeItem('adminViewUserId'); // 일반 유저 그래프는 본인(authUser)으로
	history.push('/weeklyChartList/list', {
		middleAreaSeriesData: middleAreaSeriesData,
		mainUpperAreaSeriesData: mainUpperAreaSeriesData,
		mainLowerAreaSeriesData: mainLowerAreaSeriesData,
		lineSeriesData: lineSeriesData,
		upperLimit: upperLimit,
		lowerLimit: lowerLimit
	});
	//history.push('/weeklyChartList/list');
	}

	const [userDeviceDate, setUserDeviceDate] = useState('');

	//병원 리스트
	const [hospitalList, setHospitalList] = useState([
	{
		hospital_id: 0,
		hospital_name: ''
	}
	]);

	//병원 리스트 세트
	const callHospitalApi = async () => {
	let hospitalListResult = await agmsClientRequestGet('/api/hospitals');
	setHospitalList(hospitalListResult);
	}
	const hospitalMenuItemList = hospitalList.map((item, index) => {
	return <MenuItem key={index} value={item.hospital_id}>{item.hospital_name}</MenuItem>;
	});

	//테이블 로우 값 가져오기
	const callApi = async () => {
	setTableLoading(true);
	const userId = secureLocalStorage.getItem("authUser");
	try {
		let res = null;

		//만약 Admin Staff이면 staff id가 아니라 hospital id를 기점으로 patient를 가져온다.
		if(secureLocalStorage.getItem('role') === 'ADMIN_STAFF'){
		res = await agmsClientRequestGet(
			`/api/staff/info/patient/device/hospital/${secureLocalStorage.getItem('hospitalId')}/0.0`
		);
		}
		else if(Number(secureLocalStorage.getItem('role')) === 1001){
		res = await agmsClientRequestGet(
			`/api/staff/info/patient/device/hospital/${hospital}/0.0`
		);
		}
		//아니면 staff id에 종속된 patient id만 가져온다.
		else {
		res = await agmsClientRequestGet(
			`/api/staff/info/patient/device/${userId}/0.0`
		);
		}
		setTableLoading(false);

		let patientTableList = [];
		
		res.forEach(element => {
		if(element.last_date !== null){
			let temp = {
				name: element.patient_name,
				code: element.identification,
				createdDate : element.last_date,
				patient_id : element.patient_id
			}
			patientTableList.push(temp);
		}
		});
		
		setTableData(patientTableList);//data에 저장
	} catch (error) {
		callApi();
	} 
	};

	//요약 그래프
	const callSummaryApi = async (input) =>{
		setLoading(true);
		//API Call
		try{
			let result = undefined;
			
			result = await agmsClientRequestGet(`/api/graph/summary?user_id=${USER_IDENTITY === null ? secureLocalStorage.getItem('authUser') : USER_IDENTITY}&started_dt=${userDeviceDate}`) //${secureLocalStorage.getItem('authUser')}
			//result = await agmsClientRequestGet(`/api/graph/summary?user_id=602`)
			if(result.is_success === false){
				setLoading(false);
				if(result.message === 'User device not found.'){
					setLoading(false);
				}
			}
			else{
			setAverageData(result.avgGlucose);
			setMaxData(result.maxGlucose);
			setMinData(result.minGlucose);
			setMeasurementPeriod(result.measurementPeriod);
			setActivePercent(result.activePercent);
			setDeviceTypeInfo(result.deviceType);
			
			//유효범위
			setUpperLimit(result.upperLimit);
			setLowerLimit(result.lowerLimit);

			if(result !== undefined){      
				let tempLineList = [];
				let tempMiddelAreaList = [];
				let tempUpperMainAreaList = [];
				let tempLowerMainAreaList = [];
				
				//Area그래프에 props로 넘겨줄 데이터를 가공합니다.
				for(let i = 0; i < result.profileGraphData["50%"].length; i += 4) {
				// AGP 프로파일 x축은 "하루 24시간" 더미 축(서버 시각 아님) — datetimeUTC:true 와 짝. UTC-first 무관
				let beforeUtcTempDate = new Date("2022-01-02T00:00:00");
				let tempDate = new Date(Date.UTC(beforeUtcTempDate.getFullYear(), beforeUtcTempDate.getMonth(),beforeUtcTempDate.getDate(),beforeUtcTempDate.getHours(),beforeUtcTempDate.getMinutes(),beforeUtcTempDate.getSeconds()));
				tempDate.setMinutes(tempDate.getMinutes() + 15 * i);

				let tempObject = {
					x: tempDate,
					y: Math.floor(result.profileGraphData["50%"][i])
				}
				tempLineList.push(tempObject);
				
				let tempObject1 = {
					x: tempDate,
					y: [ Math.floor(result.profileGraphData["25%"][i]),  Math.floor(result.profileGraphData["75%"][i]) ] 
				}
				tempMiddelAreaList.push(tempObject1);

				let tempObject2 = {
					x: tempDate,
					y: [ Math.floor(result.profileGraphData["75%"][i]),  Math.floor(result.profileGraphData["95%"][i]) ] 
				}
				tempUpperMainAreaList.push(tempObject2);

				let tempObject3 = {
					x: tempDate,
					y: [ Math.floor(result.profileGraphData["5%"][i]),  Math.floor(result.profileGraphData["25%"][i]) ] 
				}
				tempLowerMainAreaList.push(tempObject3);
				}

				setLineSeriesData(tempLineList);
				setMiddleAreaSeriesData(tempMiddelAreaList);
				setUpperMainAreaSeriesData(tempUpperMainAreaList);
				setLowerMainAreaSeriesData(tempLowerMainAreaList);
			}else{
			}
			setLoading(false);
			}
			
			// .then(response => {
			
			// })
			// .catch(error => {
			//   if (error.response && error.response.data) {
			//   } else {
			//   }
			// });
			
			// //로그인 되어 있을 때만 실행
			// if(secureLocalStorage.getItem('accesstoken') !== null){
			//   if(!isCurrentBloodSugar){
			//     result = await agmsClientRequestGet(`/api/report/summary/${input}`);
			//   }else{
			//     result = await agmsClientRequestGet(`/api/report/summary/${input}?strValueType=1308`);
			//   }
			// }
			return result;
		}
		catch(e){
		}
		setLoading(false);
	}

	//유저 정보
	const callUserApi = async() => {
		setTableLoading(true);
		let result = await agmsClientRequestGet(
			`/api/user/info?user_id=${secureLocalStorage.getItem('authUser')}` //USER_IDENTITY === null ? secureLocalStorage.getItem('authUser') : USER_IDENTITY
		);

		//1601 남성
		//1602 여성
		//1603 선택 안함
		let genderString = '';

		if(result.sex === "남성"){
			genderString = translate("gender_male");
		}
		else if(result.sex === "여성"){
			genderString = translate("gender_female");
		}
		else if(result.sex === "선택 안함"){
			genderString = translate("gender_none");
		}
		let object = {
			name : result.name,
			sex : genderString,
			height : result.height + ' cm',
			weight : result.weight + ' kg',
			email : result.email
		}
		secureLocalStorage.setItem('userInfo', object);
		setUserInfo(object);
		setTableLoading(false);
	}

	const callLogoutApi = async () => {
		let result = await agmsClientRequestGet(
			`/api/logout`
		);
		secureLocalStorage.removeItem("refreshtoken");
		secureLocalStorage.removeItem("accesstoken");
		secureLocalStorage.removeItem('authUser');
		secureLocalStorage.removeItem('autoLogin');
		history.push('/login');
	}

	const callUserDeviceListApi = async() => {
		try{
			setUserDeviceListLoading(true);
			let result = await agmsClientRequestGet(`/api/device/all?user_id=${USER_IDENTITY === null ? secureLocalStorage.getItem('authUser') : USER_IDENTITY}`); //secureLocalStorage.getItem('authUser')
			setUserDeviceList(result);
			setUserDeviceDate(result.length === 0 ? '' : result[0].started_dt);
		}
		finally{
			setUserDeviceListLoading(false);
		}
  	}

	useEffect(() => {
		if(userDeviceDate !== null && userDeviceDate !== ''){
			callSummaryApi();
		}
		secureLocalStorage.setItem('userDeviceStartDate', userDeviceDate);
	}, [userDeviceDate]);

	useEffect( async () => {
		
		secureLocalStorage.setItem('isCurrentBloodSugar', true);
		if(secureLocalStorage.getItem("authUser") === null){
			//로그인 정보가 없으면 로그인 화면으로
			history.push('/login');
		}
		else{
		    await callUserApi();
			await callUserDeviceListApi();	
		}

	}, []);

	
	const fontSize = {
		fontSize: '36px', // Set your desired font size here
	};

	const [hospital, setHospital] = useState(secureLocalStorage.getItem('hospitalId'));

	//병원 선택 시
	// useEffect(() => {
	//   if(location.state === undefined){
	//     if(secureLocalStorage.getItem('autoLogin') === null){
	//       callLogoutApi();
	//       secureLocalStorage.removeItem("refreshtoken");
	//       secureLocalStorage.removeItem("accesstoken");
	//       secureLocalStorage.removeItem('authUser');
	//       secureLocalStorage.removeItem('autoLogin');
	//       history.push('/login');
	//     }
	//     else{
	//       callApi();
	//     }
	//   }
	//   else if(location.state.isAfterLogin === true){
	//     callApi();
	//   }
	//   else{
	//     callApi();
	//   }
	//   secureLocalStorage.setItem('hospitalId', hospital);
	// }, [hospital]);

	const handleChange = (event) => {
		setHospital(event.target.value);
	};

	return (
		<div
			className="row w-100 h-100 d-flex align-items-center"
			style={{ 
				padding: "0px 70px",
			}
		}>
			<div className="panel-body" style={{maxWidth:'1500px', minWidth:'1400px',marginLeft:'auto', marginRight:'auto'}}>
				<div style={{
					width: '100%', 
					height: Number(secureLocalStorage.getItem('role')) === 1001 ? '60px':'50px', 
					display:'flex', 
					alignItems:'center', 
					justifyContent:'end', 
					marginTop: Number(secureLocalStorage.getItem('role')) === 1001? '10px': '0px'}}>
				</div>

				<div className="row" style={{
					minHeight:'750px'
				}}>
					<div className="col">  
					{
						tableLoading === true ?
						<div style={{
							display:'flex', 
							justifyContent:'center',
							alignItems:'center',
							backgroundColor:'white',
							maxHeight:'800px', 
							height:'75vh',
							border:'1px solid black',
							borderRadius:'3px'
						}}> 
							<CircularProgress color="secondary" />
						</div>
						:
						// <PatientTable 
						//   tableData = {tableData} 
						//   isAfterLogin = {isAfterLogin}/>
						<Card style={{
							display:'flex', 
							justifyContent:'center',
							alignItems:'center',
							flexDirection:'column',
							backgroundColor:'white',
							maxHeight:'800px', 
							height:'100%',
							border:'1px solid #8A8A8A',
							borderRadius:'3px',
							padding:'10px'
						}}> 

						<div style={{
							display:'flex',
							justifyContent:'center',
							alignItems:'center',
							flex:1,
							fontSize:'23px'
						}}>
							<b>{translate("user_profile")}</b>
						</div>
						
						
						<div style={{
							width:'100%',
							height:'100%',
							display:'flex',
							flexDirection:'row',
							flex:5
						}}>
							
							{/* 좌측  */}
							<div style={{
								flex:1,
								display:'flex',
								flexDirection:'column'
							}}>
								
								<div style={{
									display: 'flex',
									justifyContent:'end',
									alignItems:'center',
									flex:1,
									fontSize:'18px'
								}}>
									{translate("name")}
								</div>

								<div style={{
									display: 'flex',
									justifyContent: 'end',
									alignItems:'center',
									flex:1,
									fontSize:'18px'
								}}>
									{translate("gender")}
								</div>

								<div style={{
									flex:1,
									display: 'flex',
									justifyContent: 'end',
									alignItems:'center',
									fontSize:'18px'
								}}>
									{translate("height")}
								</div>

								<div style={{
									flex:1,
									display: 'flex',
									justifyContent: 'end',
									alignItems:'center',
									fontSize:'18px'
								}}>
									{translate("weight")}
								</div>

								<div style={{
									flex:1,
									display: 'flex',
									justifyContent: 'end',
									alignItems:'center',
									fontSize:'18px'
								}}>
									{translate("email")}
								</div>
							</div>

							{/* 우측 */}
							<div style={{
								flex:1.3,
								display:'flex',
								flexDirection:'column',
								marginLeft:'20px'
							}}>
								<div style={{
									display: 'flex',
									justifyContent: 'flex-start',
									alignItems:'center',
									flex:1,
									fontSize:'15px',
									backgroundColor:''
								}}>
									<div style={{
										border:'1px solid #9C9C9C',
										borderRadius:'4px',
										padding:'10px',
										width:'150px'
									}}>
										{userInfo.name}
									</div>
								</div>

								<div style={{
									display: 'flex',
									justifyContent: 'flex-start',
									alignItems:'center',
									flex:1,
									fontSize:'15px'
								}}>
									<div style={{
										border:'1px solid #9C9C9C',
										borderRadius:'4px',
										padding:'10px',
										width:'150px'
									}}>
										{userInfo.sex}
									</div>
								</div>

								<div style={{
									flex:1,
									display: 'flex',
									justifyContent: 'flex-start',
									alignItems:'center',
									fontSize:'15px'
								}}>
									<div style={{
										border:'1px solid #9C9C9C',
										borderRadius:'4px',
										padding:'10px',
										width:'150px'
									}}>
										{userInfo.height}
									</div>
								</div>

								<div style={{
									flex:1,
									display: 'flex',
									justifyContent: 'flex-start',
									alignItems:'center',
									fontSize:'15px'
								}}>
									<div style={{
										border:'1px solid #9C9C9C',
										borderRadius:'4px',
										padding:'10px',
										width:'150px'
									}}>
										{userInfo.weight}
									</div>
								</div>

								<div style={{
									flex:1,
									display: 'flex',
									justifyContent: 'flex-start',
									alignItems:'center',
									fontSize:'15px'
								}}>
									<div style={{
										border:'1px solid #9C9C9C',
										borderRadius:'4px',
										padding:'10px',
										width:'200px'
									}}>
										{userInfo.email}
									</div>
								</div>
							</div>
						</div>

						
						<div style={{
							display:'flex',
							flexDirection:'row',
							justifyContent:'center',
							alignItems:'center',
							flex:1,
							fontSize:'18px'
						}}>
							<div>
							{translate("target_glucose_range")} 
							</div>
							<div style={{
								display:'flex',
								flexDirection:'row',
								justifyContent:'center',
								alignItems:'center',
								marginLeft:'10px'
							}}>
							<div><b>70</b>mg/dL</div>
							&nbsp; ~ &nbsp;
							<div><b>180</b>mg/dL</div>
							</div>
						</div>
						<div style={{
							display: 'flex',
							justifyContent:'center',
							alignItems:'center',
							flexDirection:'row',
							fontSize:'18px',
							width:'100%',
						}}>

							{
								secureLocalStorage.getItem('role') === '1001' ?
								<div style={{
									display: 'flex',
									justifyContent:'center',
									alignItems:'center',
									flexDirection:'row',marginLeft:'auto'
								}}>
									<div style={{marginRight:'10px'}}>
										<FormControlLabel
											control={<Switch />}
											label="활성화"
										/>
									</div>
									<Button variant="contained" style={{marginRight:'10px'}}>
										수정
									</Button>

									<Button variant="contained" color="error" >
										삭제
									</Button>
									

								</div>
								:
								<></>
							}
							

							
								
						</div>
						</Card>
						
					}
					
					</div>
				
					<div style={{width:'10px', height:'10px'}}></div>

					<div className="col">
						<Card sx={{ minWidth: 275, height: '100%', border: '1px solid #8A8A8A'}}>
							<CardContent style={{height:'100%'}}>
								<Box style={{display:'flex', flexDirection:'column',height:'100%'}}>

									{
										secureLocalStorage.getItem('role') === '1001' ? 
										<></>
										:
										<Box sx={{ flex: 1}}>
											<Grid container spacing={2}>
												<Grid xs={4}>
													<Item >
														<div className="row" style={{fontSize:'16px'}}>{translate("average_value")}({isCurrentBloodSugar? 'mg/dL':'nA'})</div>
														<div className="row" style={fontSize}>
															{loading !== true ? 
																<b>{Math.round(averageData)}</b>
															: 
																<div style={{height:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'13px', marginBottom:'8px'}}>
																	<CircularProgress size="30px"/>
																</div>
															}
														</div>
													</Item>
												</Grid>
												<Grid xs={4}>
													<Item >
														<div className="row" style={{fontSize:'16px'}}>{translate("max_value")}({isCurrentBloodSugar? 'mg/dL':'nA'})</div>
														<div className="row" style={fontSize}>
															{loading !== true ? 
																<b>{Math.round(maxData)}</b>
															: 
																<div style={{height:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'13px', marginBottom:'8px'}}>
																	<CircularProgress size="30px"/>
																</div>
															}
														</div>
													</Item>
												</Grid>
												<Grid xs={4}>
													<Item >
														<div className="row" style={{fontSize:'16px'}}>{translate("min_value")}({isCurrentBloodSugar? 'mg/dL':'nA'})</div>
														<div className="row" style={fontSize}>
															{loading !== true ? 
																<b>{Math.round(minData)}</b>
															: 
																<div style={{height:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'13px', marginBottom:'8px'}}>
																	<CircularProgress size="30px"/>
																</div>
															}
														</div>
													</Item>
												</Grid>

												<Grid xs={4}>
													<Item >
														<div className="row" style={{fontSize:'16px'}}>{translate("measurement_days")}</div>
														<div className="row" style={fontSize}>
															{loading !== true ? 
																<b>{measurementPeriod} {translate("day")}</b>
															: 
																<div style={{height:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'13px', marginBottom:'9px'}}>
																	<CircularProgress size="30px"/>
																</div>
															}
															
														</div>
													</Item>
												</Grid>
											</Grid>
										</Box>
									}
									
									
									<Box style={{flex: 4, marginTop:'20px', marginBottom:'20px', textAlign:'center'}}>
										<ClickableList userDeviceList={userDeviceList} setUserDeviceDate={setUserDeviceDate} loading={userDeviceListLoading}/>
									</Box>
									
									{
										secureLocalStorage.getItem('role') === '1001' ?
										<></>
										:
										<Box style={{flex: 0.2, display:'flex', justifyContent:'center', alignItems:'center'}}>
											<Button fullWidth variant="contained" size="medium"
												disabled={userDeviceListLoading || !userDeviceDate}
												style={{backgroundColor : (userDeviceListLoading || !userDeviceDate) ? '#ECEAF0' : '#DBD7E1', color:'#000000', fontSize:'16px'}} onClick={handleToWeeklyChart}>
												<b>{translate("daily_data_view")}</b>
											</Button>
										</Box>
									}
									
								</Box>
							</CardContent>
						</Card>  
					</div>
				</div>
			</div>
		</div>
	);
};

export default withRouter(PatientList);
